import { Button, Card, Checkbox, DatePicker, Form, Icon, InputNumber, Mentions, message, Select, Spin, Tooltip } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";

import { OptionProps } from "antd/lib/mentions/index";
import { stringify } from "query-string/index";
import SubList from '../../components/SubList';
import AssetSearch from '../../components/AssetSearch';
import moment from 'moment';

// Function to convert seconds to hours (decimal)
function secondsToHours(seconds) {
  return (seconds / 3600).toFixed(2);
}

const { Option, getMentions } = Mentions;
const columns = ['name', 'lastDate', 'location', 'days'];

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      asset: null,
      lastReading: null,
      models: []
    }
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.lastReading) {

      this.setState({ lastReading: nextProps.lastReading })
    }

    if (nextProps && nextProps.data && nextProps.data.asset) {
      this.setState({ asset: nextProps.data.asset._id })
    }

    // console.log(nextProps);
    if (nextProps && nextProps.assetDetail && JSON.stringify(nextProps.assetDetail) !== JSON.stringify(this.props.assetDetail)) {
      console.log('assetDetail =>', nextProps.assetDetail);
      this.setState({
        models: nextProps.assetDetail.assetModel && nextProps.assetDetail.assetModel.meters || []
      })
    }

  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);
      if (this.state.asset) {

        if (match.params && match.params.id) {
          this.props.onSubmit({ ...data, asset: this.state.asset, readingTime: data.readingTime.unix() }, match.params.id);
        } else {
          this.props.onSubmit({ ...data, asset: this.state.asset, readingTime: data.readingTime.unix() });
        }
      } else message.error(`Asset is required`)
    });
  };


  getLastReading = (_, meter) => {
    const asset = this.state.asset;
    let meterUnit = meter;
    if (asset && !meterUnit && this.props.form && this.props.form.getFieldValue) {
      meterUnit = this.props.form.getFieldValue('unit')
    }
    if (asset && meterUnit) {
      console.log('getting last reading');

      this.props.getLastReading(asset, meterUnit)
    }
  }


  assetSearch = (value) => {
    this.props.searchGlobalAssetData(value);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form, assetData, assetSearchLoading } = this.props;

    // console.log('data =>', data);

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>

          <div style={{ color: 'red', fontSize: '15px' }}>{this.state.lastReading && `Last Reading was : ${this.state.lastReading.reading}`}</div>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource} />
              } else {
                if (item === 'asset') {
                  return <Form.Item
                    key={"asset"}
                    label={"Enter Asset"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`asset`, {
                      rules: [{ required: true, message: `Asset is required!` }],
                      initialValue: data && data.asset && data.asset._id || this.state.asset,
                    })(

                      <AssetSearch
                        styleName="gx-lt-icon-search-bar-lg"
                        onChange={this.assetSearch.bind(this)}
                        onSelect={(value) => {
                          this.setState({ asset: value }, () => {
                            this.getLastReading(null, null)
                            if (this.props.getAssetDetail)
                              this.props.getAssetDetail(value)
                          })
                        }}
                        assetData={
                          assetData && assetData.filter((ast) => ast.assetModel)
                        } // only assets with assetModel
                        authUser={this.props.authUser}
                        loading={assetSearchLoading}
                        defaultAsset={data && data.asset}
                      />,
                    )}
                  </Form.Item>
                } if (item === 'unit') {
                  return <Form.Item
                    key={"unit"}
                    label={"Meter Unit"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`unit`, {
                      rules: [{ required: true, message: `Meter is required!` }],
                      initialValue: data && data.unit && data.unit._id,
                    })(
                      <Select
                        onSelect={(v) => this.getLastReading(null, v)}
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Please select Meter"
                        disabled={title === 'EDIT' || !this.state.models || !this.state.models.length}
                      >
                        {this.state.models.map(item => <Select.Option key={item._id}
                          value={item._id}>{item.name}</Select.Option>)}
                        {title === 'EDIT' &&
                          <Select.Option key={data && data.unit && data.unit._id}
                            value={data && data.unit && data.unit._id}>{data && data.unit && data.unit.name}</Select.Option>
                        }
                      </Select>

                    )}
                  </Form.Item>
                } if (item === 'readingTime') {
                  return <Form.Item
                    key={"readingTime"}
                    label={"Reading Time"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`readingTime`, {
                      rules: [{ required: true, message: `Time is required!` }],
                      initialValue: data && data.readingTime && moment.unix(data.readingTime),
                    })(
                      <DatePicker showTime
                        disabled={((title === 'EDIT' || title === 'VIEW') && filters['readingTime'] && filters['readingTime'].options.disabledOnEdit) || false} />

                    )}
                  </Form.Item>
                } else if (item !== 'lastIotReadingTime' && item !== 'lastIotReading')
                  return getFormFieldByType(filters, item, getFieldDecorator, data)
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
